<template>
  <div>
    <div class="page_title flex_between">
      <span>药师详情</span>

      <el-button type="primary" style="width:92px;" size="medium" @click="back">返回</el-button>
    </div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div style="margin-bottom:18px">
          <span class="itemtitle">提交日期：</span>
          <span>{{detail.update_time}}</span>
          <span class="itemtitle" style="margin-left:50px">账号：</span>
          <span>{{detail.user_phone}}</span>
        </div>
        <div class="itemtitle">基本信息</div>
        <div class="infobox">
          <div style="margin-bottom:20px">
            <span style="display:inline-block;width:300px">
              <span class="gray">姓名：</span>
              <span class="black">{{detail.real_name}}</span>
            </span>
            <span>
              <span class="gray">性别：</span>
              <span class="black" v-if="detail.sex==1">男</span>
              <span class="black" v-if="detail.sex==2">女</span>
            </span>
          </div>
          <div style="margin-bottom:20px">
            <span style="display:inline-block;width:300px">
              <span class="gray">身份证号：</span>
              <span class="black">{{detail.id_card}}</span>
            </span>
            <span>
              <span class="gray">职称：</span>
              <span class="black">{{detail.title}}</span>
            </span>
          </div>
          <div>
            <span style="display:inline-block;width:300px">
              <span class="gray">执业资格证号：</span>
              <span class="black">{{detail.certificate_no}}</span>
            </span>
          </div>
        </div>

        <div class="itemtitle">证照资料</div>

        <div class="imglist">
          <div class="imgitem">
            <div class="imgtext">执业药师资格证</div>
            <div class="imgbox">
              <el-image class="img" :src="qualification_certificate" :preview-src-list="imgList"></el-image>
            </div>
          </div>
          <div class="imgitem">
            <div class="imgtext">面部照</div>
            <div class="imgbox">
              <el-image class="img" :src="people_face" :preview-src-list="imgList"></el-image>
            </div>
          </div>

          <div class="imgitem">
            <div class="imgtext">身份证（正面）</div>
            <div class="imgbox">
              <el-image class="img" :src="id_card_face" :preview-src-list="imgList"></el-image>
            </div>
          </div>
          <div class="imgitem">
            <div class="imgtext">身份证（反面）</div>
            <div class="imgbox">
              <el-image class="img" :src="id_card_side" :preview-src-list="imgList"></el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import axios from "../../../service/axios/axios";
import hospital from "../../../api/hospital";
import _ from "lodash";
export default {
  data() {
    return {
      qualification_certificate: "",
      people_face: "",
      id_card_face: "",
      id_card_side: "",
      detail: {},
      imgList: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取详情
    getReviewed() {
      let admin_id = this.$route.query.admin_id;
      hospital
        .getPharmacistInfo({ admin_id })
        .then(res => {
          if (res.code == 0) {
            this.detail = res.data.info;
            let data = res.data.info;
            this.detail.update_time = platform.timestampToDate(
              this.detail.update_time
            );
            this.requestImg(
              data.qualification_certificate,
              "qualification_certificate"
            );
            this.requestImg(data.people_face, "people_face");
            this.requestImg(data.id_card_face, "id_card_face");
            this.requestImg(data.id_card_side, "id_card_side");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    requestImg(src, imgname) {
      let value = this.getUrlParam("resources_id", src);
      this.axios
        .get("doctor/cms/getImg", {
          params: { resources_id: value }
        })
        .then(res => {
          this[imgname] = res;
          this.imgList.push(res);
        });
    },
    getUrlParam(key, url) {
      var reg = new RegExp("(^|\\?|&)" + key + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },

    back() {
      history.back();
    }
  },
  created() {
    this.getReviewed();
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 24px 20px;
  box-sizing: border-box;
  background: #ffffff;
  min-width: 1000px;
  text-align: left;
  min-height: calc(100vh - 140px);
}

.black {
  color: #000;
}
.gray {
  color: #666;
  display: inline-block;
  text-align: right;
  width: 100px;
}
.itemtitle {
  color: #333;
  font-weight: 600;
  margin-bottom: 12px;
}
.infobox {
  height: 100%;
  border: solid 1px #cfcece;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.imglist {
  padding-right: 240px;
  display: flex;
  justify-content: space-between;
  .imgitem {
    width: 200px;
    .imgbox {
      width: 200px;
      height: 140px;
      border: solid 1px #d6d6d6;
      padding: 10px;
      box-sizing: border-box;
      .img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
    .imgtext {
      color: #737982;
      font-weight: 600;
      margin-bottom: 8px;
    }
  }
}
.status {
  display: inline-block;
  border-radius: 2px;
  height: 30px;
  line-height: 30px;
  padding: 3px 8px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 400;
}
</style>